// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"620":"343e2b0d","623":"85ce1dca","681":"b32c4ced","704":"65d727e2"}[chunkId] + ".css";
};